import { render } from "./RecipientTechnicalDetails.vue?vue&type=template&id=4986b466&scoped=true&ts=true"
import script from "./RecipientTechnicalDetails.vue?vue&type=script&lang=ts"
export * from "./RecipientTechnicalDetails.vue?vue&type=script&lang=ts"

import "./RecipientTechnicalDetails.vue?vue&type=style&index=0&id=4986b466&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4986b466"]])

export default __exports__